import { Button, Group, Stack } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { WorkloadReportContent } from "./WorkloadReportContent";

export { WorkloadReportContent } from "./WorkloadReportContent";

export default function WorkloadReportPage() {
  return (
    <Stack gap="lg" p="md">
      <Group>
        <Button
          component={Link}
          to="/reports"
          variant="subtle"
          leftSection={<IconArrowLeft size={16} />}
        >
          Reports
        </Button>
      </Group>
      <WorkloadReportContent />
    </Stack>
  );
}
